<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card
      flat
      :loading="loading"
    >
      <v-card-text>
        <v-icon @click="drawer = false"> close </v-icon>
      </v-card-text>
      <v-card-title v-if="!loading"> Add Option Image </v-card-title>
      <v-card-text v-if="!loading">
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-file-input
            v-model="file"
            label="Image to upload"
            outlined
            accept="image/*"
            :rules="[$rules.required]"
          />
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'PrintAddOptionImage',
  components: {},
  data() {
    return {
      loading: false,
      valid: false,
      drawer: false,
      saving: false,
      file: null,
      option: {}
    };
  },

  computed: {
    ...mapGetters({})
  },

  mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.ADD_PRINT_OPTION_IMAGE_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.ADD_PRINT_OPTION_IMAGE_SHOW, (data) => {
      this.option = data.option;
      this.file = null;
      this.drawer = true;
    });
  },

  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch('print/addOptionImage', {
            optionId: this.option.id,
            file: this.file
          })
          .then(() => {
            this.$root.$snackbarSuccess('Option Image added');
            this.drawer = false;
          })
          .catch((error) => {
            this.logError(error);
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
